import {connect} from 'react-redux';
import {reduxForm, destroy} from 'redux-form';
import {push} from 'react-router-redux';

import ParentForm from './ParentForm'
import {getParentDataAsPOJO, saveParentData} from './parent';
import {getIsInternalUse} from "../../main";

// <editor-fold desc="redux-form specific code">
// Check data
function validate(values, props) {
  let errors = {};
  if (!values.vorname) {
    errors.vorname = "Bitte geben Sie ihren Vornamen an.";
  }
  if (!values.nachname) {
    errors.nachname = "Bitte geben Sie ihren Nachnamen an.";
  }
  if (!values.strasse) {
    errors.strasse = "Bitte geben Sie Straße und Hausnummer an.";
  }
  if (!values.plz) {
    errors.plz = "Bitte geben Sie ihre Postleitzahl an.";
  }
  if (!values.ort) {
    errors.ort = "Bitte geben Sie ihre Ort an.";
  }
  if (!values.email) {
    errors.email = "Bitte geben Sie ihre E-Mail-Adresse an.";
  }
  if (props.isInternalUse === false && !values.email2) { // Wird die Form als "internalUse", also für die Telefonanmeldung, verwendet muss die zweite E-Mail nicht eingegeben werden.
    errors.email2 = "Bitte wiederholen Sie ihre E-Mail-Adresse.";
  }
  if (props.isInternalUse === false && values.email && values.email2 && values.email !== values.email2) {
    errors.email = "Die E-Mail Adressen stimmen nicht überein.";
    errors.email2 = "Die E-Mail Adressen stimmen nicht überein.";
  } else if (values.email) {
    let emailRegularExpression = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let found = values.email.match(emailRegularExpression);
    if (!found) {
      errors.email = "Bitte Adresse korrigieren";
      errors.email2 = "Bitte Adresse korrigieren";
    }
  }

  let telefonError = "Bitte geben Sie mindestens eine Telefonnummer an.";
  errors.telefon = [telefonError, telefonError, telefonError];
  if (typeof(values.telefon) !== 'undefined') {
    switch (values.telefon.length) {
      case 3:
        if (values.telefon[2] && values.telefon[2].replace(/\s/g, "") !== "")
          errors.telefon = undefined;
      /* falls through */
      case 2:
        if (values.telefon[1] && values.telefon[1].replace(/\s/g, "") !== "")
          errors.telefon = undefined;
      /* falls through */
      case 1:
        if (values.telefon[0] && values.telefon[0].replace(/\s/g, "") !== "")
          errors.telefon = undefined;
        break;
      default:
        let telefonError = "Bitte geben Sie mindestens eine Telefonnummer an.";
        errors.telefon = [telefonError, telefonError, telefonError];
    }
    // Alles ok. Es ist mindestens eine Telefonnummer angegeben
  }

  return errors;
}

// Handle data sent by redux-form onSubmit
function handleSubmit(values, dispatch, props) {
  dispatch(
    saveParentData(
      values.vorname,
      values.nachname,
      values.strasse,
      values.plz,
      values.ort,
      values.email,
      values.telefon[0],
      values.telefon[1],
      values.telefon[2],
      values.einverstaendnisWaehrendDerWoche,
      values.einverstaendnisUnterDemJahr,
    )
  );
  props.onNext();
}

// Decorate the form component
const ReduxFormDecoratedParentForm = reduxForm({
  form: 'parent',
  destroyOnUnmount: false,
  onSubmit: handleSubmit,
  pure: true,
  validate: validate
})(ParentForm);
// </editor-fold>

// You have to connect() to any reducers that you wish to connect to yourself
function mapStateToProps(state) {
  let parentData = getParentDataAsPOJO(state.parent);
  let isInternalUse = getIsInternalUse(state.main);
  if (isInternalUse && !parentData.email)
    parentData.email = 'anmeldung-jugendprogramm@ratzgiwatz.de';

  return {
    viewportWidth: state.main.get('viewportWidth'),
    initialValues: {
      vorname: parentData.vorname,
      nachname: parentData.nachname,
      strasse: parentData.strasse,
      plz: parentData.plz,
      ort: parentData.ort,
      email: parentData.email,
      email2: parentData.email,
      telefon: [parentData.telefonPrivat, parentData.telefonMobil, parentData.telefonGeschaeftlich],
      einverstaendnisWaehrendDerWoche: parentData.einverstaendnisWaehrendDerWoche,
    },
    isInternalUse: isInternalUse,
  }
}

/* Every function will be wrapped in a dispatch() call by connect() -> that way it can be called by the component
 * without having to know anything about  redux and the dispath() function. That also means that each function in
 * this object is supposed to be an action creator.
 */
function mapDispatchToProps(dispatch, ownProps) {
  return {
    saveParentData: () => {
      dispatch(saveParentData);
      dispatch(destroy("parent"));
    }, // bind saveData action creator
    onNext: () => {
      dispatch(destroy("parent"));
      dispatch(push(ownProps.nextRoute));
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReduxFormDecoratedParentForm);





// WEBPACK FOOTER //
// ./src/components/parent/ParentComponent.js